import React from "react";
import Router from "next/router";
import LaunchGame from "@/Games/openGame";
import Image from "next/image";
import { getQueryVariable, isThisAllowGuestOpenGame } from '$ACTIONS/helper'
import { connect } from "react-redux";
import GameStatic from "$DATA/game.static.js";
import { ApiPort } from "$ACTIONS/TLCAPI";
import { get } from '$ACTIONS/TlcRequest';
import {
    changeTabAction,
} from "$STORE/thunk/promotionThunk";
import { translate } from "$ACTIONS/Translate";
import { message } from "antd";
import { setSmarticoLoginContinue } from "../../store/thunk/gameThunk";
import { defaultImgageUrl } from "../ImageWithFallback";
import { getGame2ndLevelRouteName } from "$ACTIONS/util";
import LinkHelper from "@/LinkHelper";

class Banner extends React.Component {
    constructor() {
        super();
        this.state = {
            WalletCloseBanner: false,
        };
    }
    componentDidMount() {
        this.setState({
            WalletCloseBanner: sessionStorage.getItem("WalletCloseBanner"),
        });
    }

    CloseBanner() {
        sessionStorage.setItem("WalletCloseBanner", true);
        this.setState({
            WalletCloseBanner: true,
        });
    }

    /**
     * @description: 轮播图跳转动作
     * @param {*} data
     * @return {*}
     */

    async BannerAction(data) {
        let item = data.action;
        const isLogin = localStorage.getItem("access_token");
        const gmaeCategories = this.props.gameInfo?.categories ?? [];
        const gamesToFilter = this.props.gameInfo?.gamesToFilter ?? [];
        console.log(data);
        if (!item.actionId || item.actionId == 0) {
            return;
        }
        Pushgtagdata(
            `Home`,
            "Click Banner",
            "Home_C_Banner",
            "",
            [
                {customVariableKey: "Home_C_Banner_Title",
                    customVariableValue: data.title},
                {customVariableKey: "Home_C_Banner_Position",
                    customVariableValue: this.props.index}
            ]
            
        );
        switch (item.actionId) {
            case 28:
                if (item.url == "/rewards-centre") {
                    if (!isLogin) {
                        this.props.setSmarticoContinue(true);
                        global.goUserSign("1");
                        return
                    }
                    Router.push("/rewards-centre");
                    return;
                }
                location.href = item.url;
                break;
            case 29:
                const res = await get(ApiPort.CMSPromotionDetail + `id=${item.ID}`);
                Router.push(`/promotions?id=${item.ID}&jumpfrom=BANNER`);
                if (res.promoMainCategory === "Daily Deal") {
                    typeof this.props.changeTab === "function" && this.props.changeTab("4");
                } else {
                    typeof this.props.changeTab === "function" && this.props.changeTab("1");
                }
                break;
            case 30:
                Router.push("/sponsorship/");
                break;
            case 31:
                if(!isLogin){
                    global.goUserSign(getQueryVariable("isAgent") === "1" ? "2" : "1");
                    return;
                }
                global.showDialog({ key: 'wallet:{"type": "deposit"}' });
                break;
            case 32:
            case 34:
                if(["HOME","DEEPLINK"].some((type) => type === item.sportLaunchType)){
                     // Deeplink 目前僅CXFUN88-4276使用，且限im
                    let gameInfo = {
                        gameCatCode: "Sportsbook",
                        provider: "IPSB",
                        gameId: "0",
                        OpenGamesListPage: false
                    }
                    if(item.sportLaunchType === "HOME"){
                        //仅打开IM体育
                        this.QuickStartGame.openGame(gameInfo);
                        return;
                        
                    }
                    if(item.sportLaunchType === "DEEPLINK"){
                        //打开IM体育，需修改返回的gameurl然后再打开游戏URL
                        if(item.eventId && item.sportId){
                            gameInfo={
                                ...gameInfo,
                                event_Id:item.eventId,
                                sport_Id:item.sportId
                            }
                            this.QuickStartGame.openGame(gameInfo);
                            return;
                        }
                        else{
                            //仅打开IM体育
                            this.QuickStartGame.openGame(gameInfo);
                            return;
                        }
                    }
                }

                let gameCatCode,type;
                const codelist = gmaeCategories
                    .flatMap(category =>
                        (category.subProviders || [])
                            .filter(subProvider => subProvider.code && !gamesToFilter.includes(subProvider.code))
                            .map(subProvider => subProvider.code)
                    );

                if (codelist.includes(item.cgmsVendorCode)) {
                    const itemCode = gmaeCategories.find(category =>
                        category.subProviders.some(subProvider => subProvider.code === item.cgmsVendorCode)
                    )?.code;

                    if (itemCode) {
                        gameCatCode = GameStatic.find(data => data.providerName === itemCode)?.providerName;
                        type =  gmaeCategories.find(category =>
                            category.subProviders.some(subProvider => subProvider.code === item.cgmsVendorCode)
                        )?.type;
                    }
                }
                if(!gameCatCode){
                    message.error(`${item.cgmsVendorCode,translate("游戏不存在")}`);
					return;
                }
                let GameData = {
                    gameCatCode: gameCatCode,
                    provider: item.cgmsVendorCode,
                    gameId: item.gameId,
                    OpenGamesListPage: type === "Category" ? true : false,
                };
                console.log("🚀 ~ Banner ~ BannerAction ~ GameData:", GameData)
                if (item.launchMode == "game_id") {
                    if (!isLogin) {
                        global.goUserSign("1");
                        return;
                    }
                    GameData.OpenGamesListPage = false;
                    this.QuickStartGame.openGame(GameData);
                    return;
                }
                if (item.launchMode == "lobby" || item.launchMode == "web_view") {
                    const IS_ALLOW_GUEST_OPEN_IFRAME_OR_NEW_WINDOW_GAME = isThisAllowGuestOpenGame(gameCatCode, item.cgmsVendorCode);
                    //如果未登录 且 type = Game 且 不在 guestView 清單，弹出登录窗口
                    if(!isLogin && (!IS_ALLOW_GUEST_OPEN_IFRAME_OR_NEW_WINDOW_GAME && type === "Game")){
                        global.goUserSign("1");
                        return;
                    }
                    GameData.OpenGamesListPage = IS_ALLOW_GUEST_OPEN_IFRAME_OR_NEW_WINDOW_GAME ? false : true;
                    this.QuickStartGame.openGame(GameData);
                    return;
                }
                break;
            case 33:
                PopUpLiveChat();
                break;
            default:
                break;
        }
    }

    getBannerHref(data) {
        let item = data.action;
        if (!item?.actionId) return null;
       
        switch (item.actionId) {
            case 28:
                return item.url;
            case 29:
                return `/promotions?id=${item.ID}&jumpfrom=BANNER`;
            case 30:
                return "/sponsorship/";
            case 32:
            case 34:
                if(["HOME","DEEPLINK"].some((type) => type === item.sportLaunchType)){
                    if(item.sportLaunchType === "DEEPLINK" && item.eventId && item.sportId){
                        return `/the-thao/im/?event_Id=${item.eventId}&sport_Id=${item.sportId}`;
                    }
                    return "/the-thao/im";
                }

                const gmaeCategories = this.props.gameInfo?.categories ?? [];
                const gamesToFilter = this.props.gameInfo?.gamesToFilter ?? [];
                const codelist = gmaeCategories
                    .flatMap(category =>
                        (category.subProviders || [])
                            .filter(subProvider => subProvider.code && !gamesToFilter.includes(subProvider.code))
                            .map(subProvider => subProvider.code)
                    );

                if (codelist.includes(item.cgmsVendorCode)) {
                    const itemCode = gmaeCategories.find(category =>
                        category.subProviders.some(subProvider => subProvider.code === item.cgmsVendorCode)
                    )?.code;

                    if (itemCode) {
                        const gameStaticData = GameStatic.find(data => data.providerName === itemCode);
                        const gameCatCode = gameStaticData?.path;

                        // Find vendorCode from getGame2ndLevelRouteName
                        const vendorCode = getGame2ndLevelRouteName(itemCode, item.cgmsVendorCode);
                        
                        if (gameCatCode) {
                            if (item.launchMode == "game_id") {
                                return `/${gameCatCode}/${vendorCode}?gameid=${item.gameId}`;
                            }
                            if (item.launchMode == "lobby" || item.launchMode == "web_view") {
                                return `/${gameCatCode}/${vendorCode}`;
                            }
                        }
                    }
                }
                break;
            default:
                break;
        }
        return null;
    }

    render() {
        const { WalletCloseBanner } = this.state;
        const { item, type, height, width, imgType, bannerFlag, bannerList } =
            this.props;
        return (
            <React.Fragment>
                {!WalletCloseBanner && (
                    <LinkHelper
                        href={this.getBannerHref(item)} 
                        blockHrefRedirection
                    >
                    <div
                        className="BannerBox"
                        style={{ padding: !type || type == "home" ? "0" : "" }}
                    >
                        <React.Fragment>
                            {type == "home" ? (
                                <Image
                                    src={item? item.cmsImageUrl : defaultImgageUrl}
                                    width={width}
                                    height={height}
                                    onClick={() => {
                                        this.BannerAction(item);
                                    }}
                                    alt={item ? item.title : ""}
                                    priority
                                />
                            ) : (
                                    <Image
                                        src={item ? item.cmsImageUrl : defaultImgageUrl}
                                        priority
                                        width={width ? width : 360}
                                        height={height ? height : 70}
                                        onClick={() => {
                                            this.BannerAction(item);
                                        }}
                                        alt={item ? item.title : ""}
                                    />
                            )}
                        </React.Fragment>
                    </div>
                    </LinkHelper>
                )}
                <LaunchGame
                    QuickStartGame={true}
                    OnRef={(QuickStartGame) =>
                        (this.QuickStartGame = QuickStartGame)
                    }
                />
            </React.Fragment>
        );
    }
}
const mapStateToProps = function (state) {
    return {
        gameInfo: state.game,
    };
}
const mapDispatchToProps = function (dispatch) {
    return {
        changeTab: (i) => {
            dispatch(changeTabAction(i));
        },
        setSmarticoContinue: (isFromSmarticoLogin) => {
            dispatch(setSmarticoLoginContinue(isFromSmarticoLogin));
        },
    };
}; 
export default connect(mapStateToProps, mapDispatchToProps)(Banner);
